import * as angular from 'angular';
import { adminCreateEditVendorsDashboardComponent } from './admin-create-edit-vendors.component';
import { topLevelAdminCreateEditVendorsComponent } from './top-level-admin-create-edit-vendors.component';


export const AdminCreateEditVendorsModule = angular.module('adminCreateEditVendorsModule', [])
  .component('topLevelAdminCreateEditVendors', topLevelAdminCreateEditVendorsComponent )
  .component('adminCreateEditVendorsDashboard', adminCreateEditVendorsDashboardComponent)
  .name;
